import { render, staticRenderFns } from "./StudentStatistics.vue?vue&type=template&id=185c5078&scoped=true&"
import script from "./StudentStatistics.vue?vue&type=script&lang=js&"
export * from "./StudentStatistics.vue?vue&type=script&lang=js&"
import style0 from "./StudentStatistics.vue?vue&type=style&index=0&id=185c5078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185c5078",
  null
  
)

export default component.exports